import React, { PropsWithChildren, useState } from 'react'
import ResizeBar from './ResizeBar'
import './ResizeableConatainer.css'

const MIN_HEIGHT = 200
const MAX_HEIGHT = 800

interface ResizeableContainerProps {
  className?: string
  children: React.ReactNode
}

// TODO: switch to PointerEvents once support is better
function ResizeableContainer({
  className = '',
  children,
}: PropsWithChildren<ResizeableContainerProps>) {
  const [height, setHeight] = useState(MIN_HEIGHT)
  let initialY: number

  const onResize = (pos: number) => {
    const clientYDiff = pos - initialY
    const newHeight = height + clientYDiff

    if (newHeight >= MIN_HEIGHT && newHeight <= MAX_HEIGHT) {
      setHeight(newHeight)
      window.dispatchEvent(new Event('resize'))
    }
  }

  const onMouseMove = (e: MouseEvent) => {
    onResize(e.clientY)
    e.preventDefault()
  }

  const onMouseUp = (e: MouseEvent) => {
    document.removeEventListener('mouseup', onMouseUp, true)
    document.removeEventListener('mousemove', onMouseMove, true)
    e.preventDefault()
  }

  const onMouseDown: React.MouseEventHandler = (e) => {
    initialY = e.clientY
    document.addEventListener('mouseup', onMouseUp, true)
    document.addEventListener('mousemove', onMouseMove, true)
    e.preventDefault()
    e.stopPropagation()
  }

  const onTouchMove = (e: TouchEvent) => {
    onResize(e.touches[0].clientY)
  }

  const onTouchEnd = () => {
    document.removeEventListener('touchmove', onTouchMove)
  }

  const onTouchStart: React.TouchEventHandler = (e) => {
    initialY = e.touches[0].clientY
    document.addEventListener('touchmove', onTouchMove)
    document.addEventListener('touchend', onTouchEnd)
  }

  return (
    <div className={className}>
      <div className="ResizeableContainer__wrapper" style={{ height }}>
        {children}
      </div>
      <ResizeBar
        direction="horizontal"
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
      />
    </div>
  )
}

export default ResizeableContainer
